import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toIntOrNull3w2d066r9pvwm as toIntOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { DriverActionException1ncfunkkb5qm9 as DriverActionException } from '../DriverActionException.mjs';
import { NativeInteractiveElementnutmif7l5rxf as NativeInteractiveElement } from '../InteractiveElement.commonHtml.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../NativeElement.commonHtml.js.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../models/data.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../reactive/Action.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Select$_get_driverActions_$slambda_k1xhu2($setter) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    yield* $($setter(joinToString(args, ' '), $completion), $completion);
    return 'OK';
  }), 1);
}
function Select$bind$slambda($alreadyHandled, this$0, $edits, $list) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if ($alreadyHandled._v) {
      return Unit_instance;
    }
    $alreadyHandled._v = true;
    // Inline function 'com.lightningkite.kiteui.views.valueString' call
    var tmp_0 = this$0.native_1.attributes_1.native_1.value;
    var tmp0_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      yield* $edits.set_revjhg_k$($list._v.get_c1px32_k$(tmp1_safe_receiver), $completion);
    }
    $alreadyHandled._v = false;
    return Unit_instance;
  }), 1);
}
function Select$bind$slambda_0($list, $render, $edits) {
  return constructCallableReference((displayText, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $list._v;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if ($render(element) === displayText) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$("No option matching '" + displayText + "'");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var item = tmp;
    yield* $edits.set_revjhg_k$(item, $completion);
    return Unit_instance;
  }), 1);
}
var SelectClass;
function Select() {
  if (SelectClass === VOID) {
    class $ extends NativeInteractiveElement() {
      constructor(context) {
        super(context);
        this._driverSelectedDisplay_1 = null;
        this._driverSelectSetValue_1 = null;
        this.native_1.tag_1 = 'select';
        this.native_1.classes_1.add_utx5q5_k$('editable');
      }
      get_driverValue_yh5neo_k$() {
        return this._driverSelectedDisplay_1;
      }
      get_driverActions_8jqr2k_k$() {
        var tmp = super.get_driverActions_8jqr2k_k$();
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var tmp0_safe_receiver = this._driverSelectSetValue_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this_0.put_4fpzoq_k$('setValue', Select$_get_driverActions_$slambda_k1xhu2(tmp0_safe_receiver));
        }
        var tmp$ret$0 = this_0.build_nmwvly_k$();
        return plus(tmp, tmp$ret$0);
      }
      bind_64a41i_k$(edits, data, render) {
        // Inline function 'kotlin.collections.listOf' call
        var list = {_v: emptyList()};
        reactive(this, VOID, ($this$reactive) => {
          list._v = $this$reactive.invoke_r7m7el_k$(data);
          var v = ReactiveState__getOrNull_impl_1asnfp(edits.get_state_wc71uu_k$());
          this.native_1.clearChildren_eufjq4_k$();
          // Inline function 'kotlin.collections.mapIndexed' call
          var this_0 = list._v;
          // Inline function 'kotlin.collections.mapIndexedTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var index = 0;
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var _unary__edvuaz = index;
            index = _unary__edvuaz + 1 | 0;
            var index_0 = checkIndexOverflow(_unary__edvuaz);
            var tmp = this.native_1;
            // Inline function 'kotlin.apply' call
            var this_1 = new (FutureElement())();
            this_1.classes_1.add_utx5q5_k$('kui');
            this_1.tag_1 = 'option';
            this_1.classes_1.add_utx5q5_k$('checkResponsive');
            var tmp0 = this_1.attributes_1;
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            var value = index_0.toString();
            tmp0.native_1.value = value;
            this_1.set_content_i5lrjv_k$(render(item));
            var tmp0_0 = this_1.attributes_1;
            // Inline function 'com.lightningkite.kiteui.views.selected' call
            var value_0 = equals(item, v);
            tmp0_0.native_1.selected = value_0;
            tmp.appendChild_gtildm_k$(this_1);
            destination.add_utx5q5_k$(Unit_instance);
          }
          return destination;
        });
        var alreadyHandled = {_v: false};
        reactive(this, VOID, ($this$reactive) => {
          var newValue = $this$reactive.invoke_r7m7el_k$(edits);
          var tmp0_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(data.get_state_wc71uu_k$());
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.collections.listOf' call
            tmp = emptyList();
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var list = tmp;
          var tmp_0;
          if (alreadyHandled._v) {
            return Unit_instance;
          }
          alreadyHandled._v = true;
          var index = list.indexOf_si1fv9_k$(newValue).toString();
          // Inline function 'kotlin.collections.find' call
          var tmp0 = this.native_1.get_children_4cwbp4_k$();
          var tmp$ret$10;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              // Inline function 'com.lightningkite.kiteui.views.valueString' call
              var tmp_1 = element.attributes_1.native_1.value;
              if (((!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : null) === index) {
                tmp$ret$10 = element;
                break $l$block;
              }
            }
            tmp$ret$10 = null;
          }
          var tmp1_safe_receiver = tmp$ret$10;
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.attributes_1;
          if (tmp2_safe_receiver == null)
            null;
          else {
            // Inline function 'com.lightningkite.kiteui.views.selected' call
            tmp2_safe_receiver.native_1.selected = true;
          }
          alreadyHandled._v = false;
          return Unit_instance;
        });
        var tmp = Companion_getInstance().send_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance_0();
        var tmp_0 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
        var setAction = Action('Set Value', tmp, VOID, VOID, tmp_0, true, Select$bind$slambda(alreadyHandled, this, edits, list));
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          tmp0_safe_receiver.addEventListener('change', (it) => {
            setAction.startAction_u0zgbm_k$(this);
            return Unit_instance;
          });
          tmp_1 = Unit_instance;
        }
        if (tmp_1 == null) {
          // Inline function 'kotlin.run' call
          var tmp_2 = this_0.eventsBack_1['on' + 'change'];
          var old = (!(tmp_2 == null) ? typeof tmp_2 === 'function' : false) ? tmp_2 : null;
          var tmp_3 = 'on' + 'change';
          this_0.eventsBack_1[tmp_3] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            setAction.startAction_u0zgbm_k$(this);
            return Unit_instance;
          };
        }
        reactive(this, VOID, ($this$reactive) => {
          this._driverSelectedDisplay_1 = render($this$reactive.invoke_r7m7el_k$(edits));
          return Unit_instance;
        });
        var tmp_4 = this;
        tmp_4._driverSelectSetValue_1 = Select$bind$slambda_0(list, render, edits);
      }
      nativeApplyTheme_6heplg_k$(theme) {
        var p = this.prevThemeClass_1;
        var newClass = this.get_context_h02k06_k$().kiteUiCss_1.themeInteractive_19n8xp_k$(theme.theme_1);
        super.nativeApplyTheme_6heplg_k$(theme);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.native_1.get_children_4cwbp4_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (p == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            element.classes_1.remove_cedx0m_k$(p);
          }
          element.classes_1.add_utx5q5_k$(newClass);
        }
      }
    }
    initMetadataForClass($, 'Select');
    SelectClass = $;
  }
  return SelectClass;
}
//region block: exports
export {
  Select as Select2osqjs95yxuh6,
};
//endregion

//# sourceMappingURL=Select.commonHtml.mjs.map
